import { z } from "zod";
export const dataPermissionDtoSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    value: z.string().nullable(),
});
//# sourceMappingURL=data-permission.schema.js.map